"use client";

import { useAuth } from "@/context/AuthContext";
import { Link } from "react-router-dom";
import { LogOut } from "lucide-react";
import { Button } from "@/components/ui/button";
import { Avatar, AvatarFallback, AvatarImage } from "@/components/ui/avatar";
import {
  DropdownMenu,
  DropdownMenuContent,
  DropdownMenuItem,
  DropdownMenuTrigger,
} from "@/components/ui/dropdown-menu";
import { useMemo } from "react";

export function MainNav() {
  const { user, signOut, isLoading } = useAuth();

  const userDetails = useMemo(() => {
    if (!user) return null;

    return {
      avatarUrl: user.user_metadata?.avatar_url || "",
      fullName: user.user_metadata?.full_name || "",
      email: user.email || "",
      initials: (
        user.user_metadata?.full_name?.[0] ||
        user.email?.[0] ||
        "U"
      ).toUpperCase(),
    };
  }, [user]);

  // Don't render user menu while loading or if no user
  if (isLoading || !userDetails) {
    return (
      <div className="flex items-center justify-between border-b bg-background px-6 py-3">
        <div className="flex items-center">
          <Link
            to="/dashboard"
            className="text-xl font-bold text-primary ml-8 md:ml-0"
          >
            RateCitizen: Admin Panel
          </Link>
        </div>
      </div>
    );
  }

  return (
    <div className="flex items-center justify-between border-b bg-background px-6 py-3">
      <div className="flex items-center">
        <Link
          to="/dashboard"
          className="text-xl font-bold text-primary ml-8 md:ml-0"
        >
          RateCitizen: Admin Panel
        </Link>
      </div>

      <div className="flex items-center gap-4">
        <DropdownMenu>
          <DropdownMenuTrigger asChild>
            <Button variant="ghost" className="relative h-10 w-10 rounded-full">
              <Avatar className="h-10 w-10">
                <AvatarImage
                  src={userDetails.avatarUrl}
                  alt={userDetails.fullName || userDetails.email}
                />
                <AvatarFallback>{userDetails.initials}</AvatarFallback>
              </Avatar>
            </Button>
          </DropdownMenuTrigger>
          <DropdownMenuContent className="w-56" align="end" forceMount>
            <DropdownMenuItem className="flex flex-col items-start gap-1">
              <p className="font-medium">
                {userDetails.fullName || "Admin User"}
              </p>
              <p className="text-xs text-muted-foreground">
                {userDetails.email}
              </p>
            </DropdownMenuItem>
            <DropdownMenuItem
              onClick={() => signOut()}
              className="text-destructive focus:text-destructive"
            >
              <LogOut className="mr-2 h-4 w-4" />
              <span>Log out</span>
            </DropdownMenuItem>
          </DropdownMenuContent>
        </DropdownMenu>
      </div>
    </div>
  );
}
